import { styled } from '@mui/material/styles';
import {Tab as T} from '@mui/material';

const Tab = styled((props) => <T disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        marginRight: theme.spacing(1),
        color: 'rgba(255, 255, 255, 0.7)',
        '&.Mui-selected': {
            color: 'rgb(0,174,239)',
        },
        '&.Mui-focusVisible': {
            // backgroundColor: 'rgba(100, 95, 228, 0.32)',
        },
    }),
);


export default Tab;
